import React from 'react';

export const STRINGS = {
  titulo: {
    novo: 'NOVO CLIENTE',
    editar: 'EDITAR CLIENTE',
  },
  camposObrigatorios: 'Os campos com * são obrigatórios',
  salvar: 'Salvar',
  secoes: {
    endereco: 'ENDEREÇO',
    contatos: 'CONTATOS',
    infoComplementares: 'INFORMAÇÕES COMPLEMENTARES',
    agenda: 'AGENDA',
  },
  toast: {
    erroCarregar: {
      type: 'error' as const,
      title: 'Erro',
      description: 'Erro ao carregar cliente',
    },
    sucesso: {
      type: 'success' as const,
      title: 'Sucesso!',
      description: 'Cliente salvo com sucesso',
    },
    erroSync: {
      type: 'error' as const,
      time: 30000,
      title: 'Erro na sincronização!',
      description: React.createElement(
        React.Fragment,
        null,
        React.createElement('p', null, 'Ocorreu um erro ao tentar conectar com o sistema Beersales.'),
        React.createElement('p', null, 'O cliente foi salvo mas não foi sincronizado.'),
      ),
    },
    erroCadastro: {
      type: 'error' as const,
      title: 'Erro no cadastro',
    },
  },
  confirmacoes: {
    atencao: 'Atenção',
    carregar: 'Carregar',
    cancelar: 'Cancelar',
    sair: 'Sair',
    cpfCnpjExistente: (nome: string) =>
      `Já existe um cliente cadastrado com esse cpf/cnpj: ${nome}. Deseja carregar os dados?`,
    cpfCnpjOutraEmpresa:
      'O Cpf/ Cnpj já foi cadastrado e está vinculado a outra empresa',
    cpfCnpjOutroVendedor:
      'O Cpf/ Cnpj já foi cadastrado e está vinculado a outro vendedor',
  },
  agenda: {
    eventoInfo: (periodo: string, diaSemana: string) =>
      `Serão criados eventos na Agenda de forma ${periodo} a cada ${diaSemana}`,
  },
  inputs: {
    tipoPessoa: 'Tipo pessoa',
    status: 'Status',
    cep: 'Cep *',
    logradouro: 'Logradouro',
    numero: 'Número',
    complemento: 'Complemento',
    bairro: 'Bairro',
    cidade: 'Cidade *',
    uf: 'UF *',
    observacaoEntrega: 'Observação Entrega',
    telefoneCelular: 'Telefone/ Celular',
    email: 'E-mail',
    contatoAdicional: 'Contato adicional',
    prazo: 'Prazo',
    formaPagamento: 'Forma de pagamento',
    grupoClientes: 'Grupo de clientes *',
    tabelaPrecos: 'Tabela de Preços',
    vendedor: 'Vendedor',
    observacao: 'Observação',
    dataInicio: 'Data de início',
    frequencia: 'Frequência',
    nenhumaOpcao: 'Nenhuma opção selecionada',
    isento: 'Isento',
  },
  placeholders: {
    cep: 'Cep',
    logradouro: 'Informe o logradouro',
    numero: 'Informe o número',
    complemento: 'Informe o complemento',
    bairro: 'Informe o bairro',
    cidade: 'Informe o cidade',
    uf: 'UF',
    telefone: 'Informe o telefone',
    email: 'Informe o e-mail',
    contatoAdicional: 'Informe um contato adicional',
    prazo: 'Selecione um prazo',
    formaPagamento: 'Selecione uma forma de pagamento',
    grupoClientes: 'Selecione um grupo',
    tabelaPrecos: 'Selecione uma Tabela',
    vendedor: 'Selecione um vendedor',
  },
};
